import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../styles/style.css";

const Login = () => {
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const response = await axios.post(
        // "http://localhost/mensajeriaRX/mensajeriaRX/mensajeria/src/baseDatos/login.php",
        "./login.php",
        { correo, password }
      );

      const data = response.data;

      if (data.success) {
        // Verificar si el usuario es Administrador
        if (data.tipo && data.tipo.toLowerCase() === "administrador") {
          // Usuario autorizado - Administrador
          localStorage.setItem("sesionActiva", true);
          localStorage.setItem("nombre", data.nombre);
          localStorage.setItem("tipo", data.tipo);

          Swal.fire({
            icon: "success",
            title: `¡Bienvenido, ${data.nombre}!`,
            text: "Has iniciado sesión satisfactoriamente.",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            window.location.href = "/mensajeria";
          });
        } else if (data.tipo && data.tipo.toLowerCase() === "doctor") {
          // Usuario no autorizado - Doctor
          Swal.fire({
            icon: "warning",
            title: "Acceso Denegado",
            text: "No tienes permisos para acceder a esta aplicación. Solo los administradores pueden acceder.",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#d33",
          });

          setError("No tienes permisos para acceder. Solo administradores.");
          setCorreo("");
          setPassword("");
        } else {
          // Tipo de usuario no reconocido
          Swal.fire({
            icon: "error",
            title: "Error de Autorización",
            text: "Tipo de usuario no reconocido. Contacta al administrador del sistema.",
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
          });

          setError("Tipo de usuario no válido");
          setCorreo("");
          setPassword("");
        }
      } else {
        // Credenciales inválidas
        Swal.fire({
          icon: "error",
          title: "Error de Autenticación",
          text: "Correo electrónico o contraseña incorrectos. Por favor verifica tus credenciales.",
          confirmButtonText: "Reintentar",
          confirmButtonColor: "#d33",
        });

        setError("Correo electrónico o contraseña incorrectos");
        setCorreo("");
        setPassword("");
      }
    } catch (error) {
      console.error("Error de conexión:", error);

      Swal.fire({
        icon: "error",
        title: "Error de Conexión",
        text: "No se pudo conectar con el servidor. Por favor intenta nuevamente.",
        confirmButtonText: "Reintentar",
        confirmButtonColor: "#d33",
      });

      setError("Error de conexión. Intenta nuevamente.");
      setCorreo("");
      setPassword("");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div
        className="login-card bg-success h-100 w-100 logo-login"
        style={{
          backgroundImage: `url(/logo-blanco.png)`,
          backgroundSize: "70%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      ></div>

      <div className="login-card bg-light h-100 bg-white poppins-regular d-flex flex-column justify-content-center">
        <h2 className="login-title poppins-bold">Iniciar Sesión</h2>
        <p className="text-muted text-center mb-3">
          <small>Solo administradores pueden acceder</small>
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group f-group f-log poppins-regular">
            <label htmlFor="correo">Correo electrónico</label>
            <input
              type="email"
              id="correo"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group f-group f-log poppins-regular">
            <label htmlFor="password">Contraseña</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-control"
                disabled={isLoading}
              />
              <div className="input-group-append custom-icon-container">
                <span
                  className="input-group-text"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </span>
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-success f"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Iniciando sesión...
              </>
            ) : (
              "Iniciar Sesión"
            )}
          </button>

          {error && (
            <div className="alert alert-danger mt-3" role="alert">
              <small>{error}</small>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;
